export default __webpack_public_path__ + "static/media/happyface.a076f5a0.png";